import request from '@/utils/request'

export function login(username, password) {
  return request({
    url: '/admin/login',
    method: 'post',
    data: {
      username,
      password
    }
  })
}

export function getInfo() {
  return request({
    url: '/admin/info',
    method: 'get',
  })
}

export function getInfoNew() {
  return request({
    url: '/admin/infoNew',
    method: 'get',
  })
}

export function logout() {
  return request({
    url: '/admin/logout',
    method: 'post'
  })
}

export function fetchList(params) {
  return request({
    url: '/admin/list',
    method: 'get',
    params: params
  })
}

export function createAdmin(data) {
  return request({
    url: '/admin/register',
    method: 'post',
    data: data
  })
}

export function updatePassword(data) {
  return request({
    url: '/admin/update/password',
    method: 'post',
    data: data
  })
}

export function updateAdmin(id, data) {
  return request({
    url: '/admin/update/' + id,
    method: 'post',
    data: data
  })
}

export function updateStatus(id, params) {
  return request({
    url: '/admin/updateStatus/' + id,
    method: 'post',
    params: params
  })
}

export function deleteAdmin(id) {
  return request({
    url: '/admin/delete/' + id,
    method: 'post'
  })
}

export function getRoleByAdmin(id) {
  return request({
    url: '/admin/role/' + id,
    method: 'get'
  })
}

export function getShopListByShopIdArr(data) {
  return request({
    url: '/shop/getShopListByShopIdArr',
    method: 'Post',
    data:data
  })
}

export function allocRole(data) {
  return request({
    url: '/admin/role/update',
    method: 'post',
    data: data
  })
}

export function adminListAll(params) {
  return request({
    url: '/admin/listAll',
    method: 'get',
    params
  })
}

export function GetAdminUserList(shopid) {
  return request({
    url: '/admin/GetAdminUserList/'+ shopid,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js